import { render, staticRenderFns } from "./DashboardTrendbox.vue?vue&type=template&id=f7df7c9c&scoped=true"
import script from "./DashboardTrendbox.vue?vue&type=script&lang=js"
export * from "./DashboardTrendbox.vue?vue&type=script&lang=js"
import style0 from "./DashboardTrendbox.vue?vue&type=style&index=0&id=f7df7c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7df7c9c",
  null
  
)

export default component.exports